import { Link } from 'mds-web-ui/components/Link/GatsbyLink'
import shouldForwardProp from '@styled-system/should-forward-prop'
import styled from 'styled-components'
import { color, space, layout, border } from 'styled-system'

export const Tag = styled(Link)
  .withConfig({ shouldForwardProp })
  .attrs(props => ({
    px: props.px || 2,
    py: props.py || 2,
    borderRadius: props.borderRadius || 4,
    ...props
  }))(
  {
    backgroundColor: '#EDEEF0',
    color: '#111113',
    lineHeight: 1,
    transition: 'all 120ms ease-out',

    '&:hover': {
      backgroundColor: '#B0B4BA'
    }
  },
  border,
  color,
  space,
  layout
)
